import styled from "styled-components";
import { Box, Chip as MuiChip } from "@mui/material";

/* istanbul ignore next */
export const SelectBox = styled(Box)`
  gap: ${(props): string => props.theme.spacing(0.5)};
  display: flex;
  overflow-x: auto;

  &::-webkit-scrollbar {
    display: none;
  }
`;

/* istanbul ignore next */
export const Chip = styled(MuiChip)`
  height: ${(props): string => props.theme.spacing(5)};
`;
